// extracted by mini-css-extract-plugin
export default {"wrapper":"MessagesList_wrapper__WZaMD","messagesWrapper":"MessagesList_messagesWrapper__VpP4-","messages":"MessagesList_messages__4Oie9"};